import { Check, ArrowRight } from "lucide-react";
import { PARENT_POINTS, IMAGES } from "@/data/content";
import { Reveal } from "@/components/site/primitives";
import { useApply } from "@/context/ApplyContext";

export function ParentSection() {
  const apply = useApply();
  return (
    <section className="relative py-20 sm:py-28 bg-white" data-testid="parent-section">
      <div className="container-x grid lg:grid-cols-2 gap-12 items-center">
        <Reveal>
          <div className="overflow-hidden rounded-sm border border-[#0A1E4E]/15 bg-[#0A1E4E] p-2">
            <img src={IMAGES.library} alt="IAUE School of Basic Studies admission flyer" className="w-full rounded-sm object-contain" />
          </div>
        </Reveal>
        <div>
          <span className="overline text-[#C0202A]">For Parents &amp; Guardians</span>
          <h2 className="mt-4 font-serif text-3xl sm:text-4xl font-bold leading-[1.1] text-[#0A1E4E]">
            Your child's future deserves a serious academic environment.
          </h2>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed">
            We understand the trust you place in us. The School of Basic Studies is built around academic
            supervision, qualified lecturers and clear communication.
          </p>
          <div className="mt-7 grid grid-cols-2 gap-3">
            {PARENT_POINTS.map((p) => (
              <div key={p} className="flex items-center gap-2 text-sm font-medium text-slate-800">
                <Check size={16} className="text-[#D4AF37]" /> {p}
              </div>
            ))}
          </div>
          <button className="btn-red mt-8" onClick={() => apply?.openApply()} data-testid="parent-talk-officer">
            Speak to an Admissions Officer <ArrowRight size={16} />
          </button>
        </div>
      </div>
    </section>
  );
}
